export default "__VITE_ASSET__BLc6lWT9__"